// The phone's context (Stage 4.8f.4b): PhoneProvider.jsx fills it; usePhone() is what any page needs to call a number.
import { createContext, useContext } from "react";

export const PhoneCtx = createContext(null);
const NONE = { available: false, hasPhone: false, dial: async () => false, open: false, setOpen: () => {}, subscribe: () => () => {}, setRingContext: () => {} };
export function usePhone() { return useContext(PhoneCtx) ?? NONE; }
export function usePhoneState() { return useContext(PhoneCtx); }
